import axios from '../base/axios';
import API_KEY from './key';

const GET_ANIMATION = 'flixfrenzy/redux/GET_ANIMATION';

// eslint-disable-next-line default-param-last
const animationReducer = (state = [], action) => {
  switch (action.type) {
    case GET_ANIMATION:
      return action.payload;
    default:
      return state;
  }
};

export const getAnimation = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=16`).then((res) => {
    dispatch({
      type: GET_ANIMATION,
      payload: res.data,
    });
  });
};

export default animationReducer;
